import React from 'react';
import { compose } from "redux";
import { connect } from "react-redux";
import Profile from "./Profile";

let mapStateToProps = (state) => ({
    id: state.authPage.id,
    name: state.authPage.name,
    email: state.authPage.email,
    role: state.authPage.roles || 'ADMIN',
});

export default compose(
    connect(mapStateToProps, {})
)(Profile);
